import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
export const pageSearch = {
 /* 'customerCode': {
    title: '客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    }
  },*/
  'checkBillNo': {
    title: '对账单号',
    type: 'input',
    equation: all
  },
  'startday': {
    title: '对账周期起',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'endday': {
    title: '对账周期至',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  }/*,
  'createdDate': {
    title: '创建日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },*/
}

export default {
  'checkBillNo': {
    title: '对账单号',
    slot: true,
    width: 'auto'
  },
  'createdDate': {
    title: '对账日期',
    width: 'auto'
  },
  'startday': {
    title: '对账周期起',
    width: 'auto'
  },
  'endday': {
    title: '对账周期止',
    width: 'auto'
  },
  'createdByName': {
    title: '操作人',
    width: 'auto'
  }

}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/deliveryCheckSearch.js